import React, { useEffect, useMemo, useState } from 'react';
import {
  Wrapper,
  Title,
  Subtitle,
  Content,
  DetailContent,
  PlanContent,
  SubWrapper,
  Subtitle2,
  BreadCrumb,
  TitleWrapper,
  IconAlert,
  FooterContent,
  Link,
  IconBack,
  IconNext,
  DivIconNext,
  Container2,
} from './styles';

import { FiFileText } from 'react-icons/fi';
import { BiCalendar } from 'react-icons/bi';
import { BsFillTagFill } from 'react-icons/bs';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getProposalDetails } from '../../store/proposal/actions';
import { page } from '../../store/auth/actions';
import { useHistory, useLocation } from 'react-router-dom';
import ModalContracts from '../../components/Modal/Contracts';
import ModalClaimPayment from '../../components/Modal/ClaimPayment';
import formatPrice from '../../services/utils/formatPrice';
import { navigationUrl } from '../../store/analytic/actions';
import { getContractsFromDealOrDebt } from '../../utils/getContractsToShow';
import getContractDescription from '../../utils/getContractDescription';

type ProposalProps = {
  contract: GQL.IDebt;
};

const Proposal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [openClaimPayment, setOpenClaimPayment] = useState(false);
  const location = useLocation<ProposalProps>();
  const contract: GQL.IDebt = location.state && location.state.contract;
  const history = useHistory();
  const dispatch = useDispatch();
  const list = useSelector((state: ApplicationState) => state.proposal.list);

  const contractsToShow = useMemo(() => getContractsFromDealOrDebt(contract), [
    contract,
  ]);

  useEffect(() => {
    if (contract) {
      dispatch(getProposalDetails.request());
      dispatch(page('contrato'));
      dispatch(
        navigationUrl.request({
          action: '/propostas',
          creditor: contract.creditorName,
          dealValue: contract.updatedValue,
          dealType: contract.proposalType,
          delay: contract.longerDelay,
        })
      );
    } else {
      history.push('/contrato');
    }
  }, [dispatch, contract, history]);

  const abstract = (proposal: GQL.IProposalDetails) => {
    history.push({
      pathname: '/resumo-proposta',
      state: { contract, proposal },
    });
  };

  const handlerClose = (): void => {
    setOpen(false);
  };

  const handlerOpen = () => {
    setOpen(true);
  };

  const handlerCloseClaimPayment = (): void => {
    setOpenClaimPayment(false);
  };

  const handlerOpenClaimPayment = () => {
    setOpenClaimPayment(true);
  };

  return (
    <Wrapper>
      <Container2>
        <TitleWrapper>
          <IconBack onClick={() => history.goBack()} />
          <Title>Meu Débito</Title>
          <BreadCrumb>
            <span id='link' onClick={() => history.push('/contrato')}>
              Meus Débitos
            </span>
            <span id='bar'> / </span>Meu Débito
          </BreadCrumb>
        </TitleWrapper>
        <SubWrapper>
          <Subtitle>
            Valor da dívida: R$ {contract && formatPrice(contract.updatedValue)}
          </Subtitle>
          <DetailContent style={{ width: '100%' }}>
            <div className='bank-name'>
              <span>{contract && contract.creditorName}</span>
            </div>
            <div className='default'>
              <FiFileText className='space-right' />
              {contract && contract.contracts.length > 1
                ? `Múltiplos contratos: `
                : `Contrato: `}
              {contract && contract.contracts.length === 1 && (
                <strong className='space-left'>
                  {contract && contract.contracts[0]}
                </strong>
              )}
              {contract && contract.contracts.length > 1 && (
                <Link onClick={() => handlerOpen()}>
                  {'Clique para exibir'}
                </Link>
              )}
            </div>
            {contract &&
              contract.contracts.length === 1 &&
              getContractDescription(contractsToShow[0])}
            <div className='default'>
              <BiCalendar className='space-right' />
              Vencimento da entrada:{' '}
              <span>
                <strong>
                  {moment(contract && contract.proposalDueDate).format(
                    'DD/MM/YYYY'
                  )}
                </strong>
              </span>
            </div>
          </DetailContent>
          <Subtitle2>OPÇÕES DE PAGAMENTO</Subtitle2>
          {list.map((proposal, index) => (
            <Content key={index} onClick={() => abstract(proposal)}>
              <PlanContent>
                <span>{proposal.plan}x</span>
              </PlanContent>

              <DetailContent>
                <div className='contentText'>
                  <span className={'spanContent'}>
                    {proposal.plan === 1 ? 'À Vista' : 'Entrada de'}
                  </span>
                  <Subtitle>R$ {formatPrice(proposal.entryValue)}</Subtitle>
                  {proposal.plan > 1 && (
                    <div className='default2'>
                      <span>
                        + {proposal.plan - 1} parcelas de R$
                        {formatPrice(proposal.portionValue)}
                      </span>
                    </div>
                  )}
                </div>
              </DetailContent>
              <DivIconNext>
                <IconNext />
              </DivIconNext>
            </Content>
          ))}

          <FooterContent>
            <IconAlert className='alert-proposal-icon' />
            <span>
              Caso este valor já tenha sido regularizado, por favor alegue
              pagamento
              <Link onClick={() => handlerOpenClaimPayment()}>
                clicando aqui
              </Link>
              .
            </span>
          </FooterContent>
        </SubWrapper>

        {open && (
          <ModalContracts
            handlerClose={handlerClose}
            contracts={contractsToShow}
          />
        )}
        {openClaimPayment && (
          <ModalClaimPayment
            databaseId={contract.databaseId}
            contracts={contract && contract.contracts}
            handlerClose={handlerCloseClaimPayment}
          />
        )}
      </Container2>
    </Wrapper>
  );
};

export default Proposal;
